import {OktaAuth} from '@okta/okta-auth-js';
import {Route, Routes} from 'react-router-dom';

import Security from 'components/app/Security';
import RouteController from 'components/mobileBridge/RouteController';
import {getRoute} from 'config/navigation';
import {StaticConfig} from 'config/staticConfig';
import SkipLink from 'shared/components/SkipLink';
import oktaAuth, {onAuthRequired, restoreOriginalUri} from 'shared/utils/okta/okta-client';
import Loadable, {Suspense} from 'utils/Loadable';

const AsyncLogin = Loadable({loader: () => import('features/Login/components/Pages')});
const ReduxPages = Loadable({loader: () => import('components/app/App/ReduxPages')});

export const AppPages = () => (
  <Security oktaAuth={oktaAuth as OktaAuth} {...{onAuthRequired, restoreOriginalUri}}>
    <SkipLink />
    {StaticConfig.mobileApplicationLoader && <RouteController />}
    <Suspense>
      <Routes>
        <Route path={`${getRoute('/login')}/*`} element={<AsyncLogin />} />
        <Route path="*" element={<ReduxPages />} />
      </Routes>
    </Suspense>
  </Security>
);

export default AppPages;
